import { call, put, select, takeLatest } from 'redux-saga/effects';

import { COST_CATEGORY_API_MAP } from 'constants/all';

import profitItemService from 'services/profitItemsService';

import { getGroupId } from 'store/session/selectors';

import { createProfitItem, entities, types } from './actions';

export default function* root() {
  yield takeLatest(types.CREATE_PROFIT_ITEM_REQUEST, watchCreateProfitItem);
}

function* watchCreateProfitItem(action) {
  try {
    const groupId = yield select(getGroupId);
    const response = yield call(profitItemService.create, groupId, {
      ...action.payload,
      category: COST_CATEGORY_API_MAP[action.payload.category],
    });
    yield put(createProfitItem.success({ profitItem: response }));
  } catch (error) {
    yield put(createProfitItem.error(error));
  }
}

export function* initProfitItemsListPage() {
  try {
    const groupId = yield select(getGroupId);
    const response = yield call(profitItemService.list, groupId);
    yield put(entities.recieveProfitItemDefs({ profitItemDefs: response }));
  } catch (error) {
    console.error('ERROR WHEN FETCHING PRICING ITEMS', error);
  }
}
